module.exports = require("github:jspm/nodelibs-events@0.1.1/index");